module.exports = require("react-style-proptype");